/* Countdown der Aktionsleiste.

   Zwei Zustaende plus Selbstabbau:
     vor dem Start   zaehlt auf den Start, Label "Start in"
     waehrend        zaehlt auf das Ende,  Label "Nur noch"
     danach          die Leiste wird aus dem Dokument entfernt

   Das Entfernen ist Absicht und nicht nur ein display:none: Nach der Aktion
   soll oben im Shop nichts mehr stehen, auch nicht unsichtbar. Damit kann
   niemand vergessen, die Leiste abzuschalten.

   ZEITZONE: Die Zeitpunkte kommen als ISO-String MIT Offset aus dem Liquid.
   Ohne Offset saehe ein Kunde in Wien eine andere Restzeit als einer in
   Berlin.

   REIHENFOLGE: .page ist ein Flex-Container, die Theme-Ankuendigungsleiste
   traegt order:-1. Damit unsere Leiste darueber liegt, bekommt ihr
   Section-Wrapper order:-2. In lr-bday-bar.css passiert das per :has(), hier
   noch einmal per JS fuer Browser ohne :has(). */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init(bar) {
    if (bar.dataset.lrBarReady) return;
    bar.dataset.lrBarReady = '1';

    var wrap = bar.closest('[id^="shopify-section"]');
    if (wrap && !wrap.style.order) wrap.style.order = '-2';

    var start = Date.parse(bar.dataset.start);
    var end = Date.parse(bar.dataset.end);
    if (isNaN(start) || isNaN(end)) return;

    var label = bar.querySelector('[data-lr-bar-label]');
    var out = {
      d: bar.querySelector('[data-lr-bar="d"]'),
      h: bar.querySelector('[data-lr-bar="h"]'),
      m: bar.querySelector('[data-lr-bar="m"]'),
      s: bar.querySelector('[data-lr-bar="s"]')
    };
    var txtBefore = bar.dataset.labelBefore || 'Start in';
    var txtRunning = bar.dataset.labelRunning || 'Nur noch';
    var timer;

    function tick() {
      var now = Date.now();
      var target, text;

      if (now < start) {
        target = start; text = txtBefore;
      } else if (now < end) {
        target = end; text = txtRunning;
      } else {
        clearInterval(timer);
        var kill = wrap || bar;
        if (kill.parentNode) kill.parentNode.removeChild(kill);
        return;
      }

      if (label && label.textContent !== text) label.textContent = text;

      var sec = Math.floor(Math.max(0, target - now) / 1000);
      if (out.d) out.d.textContent = String(Math.floor(sec / 86400));
      if (out.h) out.h.textContent = pad(Math.floor((sec % 86400) / 3600));
      if (out.m) out.m.textContent = pad(Math.floor((sec % 3600) / 60));
      if (out.s) out.s.textContent = pad(sec % 60);
    }

    timer = setInterval(tick, 1000);
    tick();
  }

  function boot() {
    var all = document.querySelectorAll('[data-lr-bar]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
